import { inferenceHttp } from '@/lib/api/inference-client';
import { AgentsService } from '@inference.engine/api-client/web';

export interface ToolShortcut {
  slotIndex: number;
  agentId: string;
}

interface ToolShortcutService {
  listShortcuts: (args: { client: typeof inferenceHttp; throwOnError: true }) => Promise<{
    data: { items: ToolShortcut[] };
  }>;
  upsertShortcut: (args: {
    client: typeof inferenceHttp;
    throwOnError: true;
    path: { slotIndex: number };
    body: { agentId: string };
  }) => Promise<{ data: ToolShortcut }>;
  deleteShortcut: (args: {
    client: typeof inferenceHttp;
    throwOnError: true;
    path: { slotIndex: number };
  }) => Promise<void>;
}

const toolShortcutService = AgentsService as unknown as ToolShortcutService;

export const getToolShortcuts = async (): Promise<ToolShortcut[]> => {
  const response = await toolShortcutService.listShortcuts({
    client: inferenceHttp,
    throwOnError: true,
  });
  return response.data.items;
};

export const upsertToolShortcut = async (
  slotIndex: number,
  agentId: string,
): Promise<ToolShortcut> => {
  const response = await toolShortcutService.upsertShortcut({
    client: inferenceHttp,
    throwOnError: true,
    path: { slotIndex },
    body: { agentId },
  });
  return response.data;
};

export const deleteToolShortcut = async (slotIndex: number): Promise<void> => {
  await toolShortcutService.deleteShortcut({
    client: inferenceHttp,
    throwOnError: true,
    path: { slotIndex },
  });
};
